import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { EmptyIndicator, Pagination } from 'components/common';
import { Box } from 'components/common/box';
import { StatCount } from 'components/common/stats';
import {
  AchievementGroupsOfUsersList,
  AchievementUsersHeader,
  AchievementUsersSubHeader
} from '.';

import type { GetAchievementGroupCompletionsRes } from 'shared-types/responses';

const AchievementGroupsOfUsers = () => {
  const {
    messages,
    pageState: { achievement },
    theme
  } = useReduxState();

  const router = useRouter();
  const queryKeys = Object.keys(router.query);

  const { data, loading, updateData } =
    useApiData<GetAchievementGroupCompletionsRes>({
      url:
        `/admin/achievements/${achievement.id}/group-completions` +
        (queryKeys.length > 0
          ? `?${queryKeys
              .map((key) => `${key}=${router.query[key]}`)
              .join('&')}`
          : ''),
      onlyIf: Boolean(achievement.id)
    });

  const updateGroups = async () => {
    if (router.query.page !== '1') updatePage({ page: 1 });
    else await updateData();
  };

  const updatePage = ({ page }) => {
    router.replace({ query: { ...router.query, page } }, undefined, {
      shallow: true
    });
  };

  return (
    <>
      <Box
        headerContent={
          <AchievementUsersHeader
            alreadyAddedUsersByEmail={{}}
            alreadyAddedUsersByUsername={{}}
            listOfGroupCompletionIds={data?.listOfGroupCompletionIds || null}
            listOfUserIds={data?.listOfUserIds || null}
            usersWithInProgressAchievementByEmail={{}}
            usersWithInProgressAchievementByUsername={{}}
            updateUsers={updateGroups}
          />
        }
        headerContentWrap={true}
        loading={loading}
        padding={0}
        subHeaderContent={<AchievementUsersSubHeader />}
        title={
          <>
            {messages.achievementGroupConversations}

            <StatCount
              isLarge={true}
              style={{ display: 'inline-block', marginLeft: 5 }}
              value={data?.groupCompletions?.length || 0}
            />

            {data?.numberOfArchivedCompletions > 0 ? (
              <>
                <div
                  style={{
                    backgroundColor: '#ddd',
                    display: 'inline-block',
                    height: 20,
                    margin: '2px 5px 2px 10px',
                    width: 2
                  }}
                />

                <StatCount
                  isLarge={true}
                  style={{ display: 'inline-block', marginLeft: 5 }}
                  label={messages.commonArchived}
                  value={data?.numberOfArchivedCompletions}
                />
              </>
            ) : null}
          </>
        }
      >
        {data?.groupCompletions?.length ? (
          <AchievementGroupsOfUsersList
            groupCompletions={data.groupCompletions}
            updateGroups={updateGroups}
          />
        ) : (
          <EmptyIndicator icon="user-friends" title={messages.groupsEmpty} />
        )}
      </Box>

      <Pagination
        currentPage={router.query.page ? Number(router.query.page) : 1}
        numberOfPages={data?.numberOfPages || 1}
        onPageChange={updatePage}
      />
    </>
  );
};

export default AchievementGroupsOfUsers;
